package com.loyola.acessoescola

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.app_name
import acessoescola.composeapp.generated.resources.exit
import acessoescola.composeapp.generated.resources.logout_24px
import acessoescola.composeapp.generated.resources.loyola
import acessoescola.composeapp.generated.resources.loyola_24px
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.navigation.compose.rememberNavController
import com.loyola.acessoescola.services.quintadb.ErrorMessages
import com.loyola.acessoescola.ui.addnew.AddNewViewModel
import com.loyola.acessoescola.ui.adminpanel.AdminPanelViewModel
import com.loyola.acessoescola.ui.components.ErrorDialog
import com.loyola.acessoescola.ui.login.LoginViewModel
import com.loyola.acessoescola.ui.navigation.LoginDest
import com.loyola.acessoescola.ui.navigation.NavGraph
import com.loyola.acessoescola.ui.registered.RegisteredViewModel
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun App(
    registeredViewModel: RegisteredViewModel,
    loginViewModel: LoginViewModel,
    appViewModel: AppViewModel,
    addNewViewModel: AddNewViewModel,
    adminPanelViewModel: AdminPanelViewModel
) {
    var errorMessage by remember { mutableStateOf("") }

    if (errorMessage != ""){
        ErrorDialog(
            errorMessage = errorMessage,
            onErrorMessageChange = { errorMessage = it }
        )
    }
    AcessoEscolaTheme {
        ModalNavigationDrawer(
            drawerState = rememberDrawerState(DrawerValue.Closed),
            drawerContent = {  },
        ){
            val navController = rememberNavController()
            Scaffold(
                topBar = {
                    TopAppBar(
                        title = {

                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Image(
                                    painter = painterResource(Res.drawable.loyola_24px),
                                    contentDescription = stringResource(Res.string.loyola),
                                    modifier = Modifier.size(32.dp)
                                )

                                Text(
                                    text = stringResource(Res.string.app_name),
                                    textAlign = TextAlign.Center,
                                    modifier = Modifier.weight(1f)
                                )

                                IconButton(
                                    onClick = {appViewModel.singout(
                                        onSuccessCallBack = {
                                            navController.navigate(LoginDest){
                                                popUpTo(
                                                    route = navController.currentDestination?.route ?: ""
                                                ){inclusive = true}
                                            }
                                        },
                                        onErrorCallBack = {errorMessage = it ?: ErrorMessages.UNKNOWN.message}
                                    )}
                                ){
                                    Icon(
                                        imageVector = vectorResource(Res.drawable.logout_24px),
                                        contentDescription =stringResource(Res.string.exit)
                                    )
                                }
                            }

                        },

                        )
                },

            ) { paddingValues ->
                NavGraph(
                    registeredViewModel = registeredViewModel,
                    loginViewModel = loginViewModel,
                    addNewViewModel = addNewViewModel,
                    navController = navController,
                    adminPanelViewModel = adminPanelViewModel,
                    paddingValues = paddingValues
                )
            }
        }
    }
}